import axios from 'axios';

const API_KEY = '55695918-3f0edaddc3daf06a90200e5d1';
const BASE_URL = 'https://pixabay.com/api/';

export async function getImagesByQuery(query, page = 1) {
  const response = await axios.get(BASE_URL, {
    params: {
      key: API_KEY,
      q: query,
      image_type: 'photo',
      orientation: 'horizontal',
      safesearch: true,
      page: page,
      per_page: 100,
    },
  });
      return response.data;
}